<mat-toolbar class="header-toolbar" [class.scrolled]="isScrolled()">
  <div class="container header-container">
    <div class="brand-wrapper" routerLink="/">
      <span class="logo-accent">Nakel</span>Services
    </div>

    <div class="nav-wrapper">
      <nav class="desktop-nav" aria-label="Main navigation">
        <a routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
        <a routerLink="/services" routerLinkActive="active">Services</a>
        <a routerLink="/categories" routerLinkActive="active">Categories</a>
        <a routerLink="/providers" routerLinkActive="active">Providers</a>
        <a routerLink="/features" routerLinkActive="active">Features</a>
        <a routerLink="/faq" routerLinkActive="active">FAQ</a>
        <a routerLink="/contact-us" routerLinkActive="active">Contact Us</a>
        <a routerLink="/terms" routerLinkActive="active">Terms</a>
        <a routerLink="/auth/provider-register" class="provider-cta">Become a Provider</a>
      </nav>
    </div>

    <div class="actions-wrapper">
      @if (!isAuthenticated()) {
      <button mat-flat-button color="primary" class="login-btn desktop-only" routerLink="/auth/login">Sign In</button>
      } @else {
      <!-- Desktop user menu — isolated child component avoids OnPush mat-menu issue -->
      <div class="user-menu desktop-only">
        <app-user-menu
          [userImage]="userImage()"
          [userDisplayName]="userDisplayName()"
          [userEmail]="userEmail()"
          [accountRoleLabel]="accountRoleLabel()"
          [showAdminItems]="showAdminItems()"
          [showAdminRestricted]="showAdminRestricted()"
          [showProviderMenu]="showProviderMenu()"
          [showAIModels]="showAIModels()"
          [showAIAgents]="showAIAgents()"
          [imageErrored]="imageErrored()"
          (logout)="logout()"
          (clearImage)="clearImage()"
        />
      </div>

      <!-- Mobile avatar icon — visible next to hamburger when logged in -->
      <button (click)="toggleMenu()" class="mobile-avatar-btn mobile-only" aria-label="Open account menu">
        <div class="user-avatar" [class.has-image]="!!userImage() && !imageErrored()">
          @if (userImage() && !imageErrored()) {
          <img [src]="userImage()!" alt="" (error)="clearImage()" />
          } @else {
          <mat-icon>account_circle</mat-icon>
          }
        </div>
      </button>
      }

      <button mat-icon-button (click)="toggleMenu()" class="mobile-only menu-btn">
        <mat-icon>{{ isMenuOpen() ? 'close' : 'menu' }}</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>

<!-- Mobile drawer backdrop (closes drawer on click) -->
@if (isMenuOpen()) {
<div class="mobile-backdrop" (click)="closeMenu()"></div>
}

<!-- Mobile Menu Drawer -->
<div class="mobile-drawer" [class.open]="isMenuOpen()" (keydown.escape)="closeMenu()">
  <div class="mobile-drawer-header">
    <button mat-icon-button (click)="closeMenu()" aria-label="Close menu">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <nav class="mobile-nav" aria-label="Mobile navigation">
    @if (isAuthenticated()) {
    <!-- Account section at the top when logged in -->
    <div class="mobile-account">
      <div class="mobile-account-header">
        <div class="user-avatar large" [class.has-image]="!!userImage() && !imageErrored()">
          @if (userImage() && !imageErrored()) {
          <img [src]="userImage()!" alt="" (error)="clearImage()" />
          } @else {
          <mat-icon>account_circle</mat-icon>
          }
        </div>
        <div class="mobile-account-details">
          <strong>{{ userDisplayName() }}</strong>
          <span class="user-email">{{ userEmail() }}</span>
          <span class="mobile-role">{{ accountRoleLabel() }}</span>
        </div>
      </div>
      <div class="mobile-account-actions">
        @if (showAdminItems()) {
        <button mat-stroked-button class="mobile-account-action primary" routerLink="/admin/dashboard" (click)="closeMenu()">
          <mat-icon>dashboard</mat-icon>
          <span>Admin Dashboard</span>
        </button>
        }
        <div class="mobile-account-links">
          @if (showAdminItems()) {
          <a routerLink="/admin/services" (click)="closeMenu()">
            <mat-icon>build</mat-icon>
            <span>Services</span>
          </a>
          <a routerLink="/admin/jobs/overview" (click)="closeMenu()">
            <mat-icon>assignment</mat-icon>
            <span>Jobs</span>
          </a>
          <a routerLink="/admin/earnings" (click)="closeMenu()">
            <mat-icon>trending_up</mat-icon>
            <span>Earnings</span>
          </a>
          }
          @if (showAdminRestricted()) {
          <a routerLink="/admin/providers" (click)="closeMenu()">
            <mat-icon>badge</mat-icon>
            <span>Providers</span>
          </a>
          <a routerLink="/admin/users" (click)="closeMenu()">
            <mat-icon>people</mat-icon>
            <span>Users</span>
          </a>
          <a routerLink="/admin/payouts" (click)="closeMenu()">
            <mat-icon>payments</mat-icon>
            <span>Payouts</span>
          </a>
          <a routerLink="/admin/payments/paystack-credentials" (click)="closeMenu()">
            <mat-icon>account_balance_wallet</mat-icon>
            <span>Paystack</span>
          </a>
          @if (showAIModels()) {
          <a routerLink="/admin/ai-models" (click)="closeMenu()">
            <mat-icon>smart_toy</mat-icon>
            <span>AI Models</span>
          </a>
          }
          @if (showAIAgents()) {
          <a routerLink="/admin/ai-agents" (click)="closeMenu()">
            <mat-icon>psychology</mat-icon>
            <span>AI Agents</span>
          </a>
          }
          }
          <a routerLink="/account/profile" (click)="closeMenu()">
            <mat-icon>person</mat-icon>
            <span>Profile</span>
          </a>
          <a routerLink="/account/bookings" (click)="closeMenu()">
            <mat-icon>event_available</mat-icon>
            <span>Bookings</span>
          </a>
          <a (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </a>
        </div>
      </div>
    </div>
    <mat-divider class="mobile-divider"></mat-divider>
    }

    <!-- Main navigation links -->
    <div class="mobile-nav-links">
      <a routerLink="/home" (click)="closeMenu()" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}">Home</a>
      <a routerLink="/services" (click)="closeMenu()" routerLinkActive="active">Services</a>
      <a routerLink="/categories" (click)="closeMenu()" routerLinkActive="active">Categories</a>
      <a routerLink="/providers" (click)="closeMenu()" routerLinkActive="active">Providers</a>
      <a routerLink="/features" (click)="closeMenu()" routerLinkActive="active">Features</a>
      <a routerLink="/faq" (click)="closeMenu()" routerLinkActive="active">FAQ</a>
      <a routerLink="/contact-us" (click)="closeMenu()" routerLinkActive="active">Contact Us</a>
      <a routerLink="/terms" (click)="closeMenu()" routerLinkActive="active">Terms</a>
      <a routerLink="/auth/provider-register" (click)="closeMenu()" class="provider-cta-mobile">Become a Provider</a>
    </div>

    @if (!isAuthenticated()) {
    <div class="mobile-footer">
      <button mat-raised-button color="primary" class="mobile-login-btn" routerLink="/auth/login" (click)="closeMenu()">Sign
        In</button>
    </div>
    }
  </nav>
</div>
